import React from 'react';
import {
  Checkbox,
  CheckboxGroup,
  Radio,
  RadioGroup,
  Select,
  Text,
  TextArea,
  Password,
} from './Elements';

const typeToComponentMap = {
  Checkbox: (props) => <Checkbox {...props} />,
  CheckboxGroup: (props) => <CheckboxGroup {...props} />,
  Password: (props) => <Password {...props} />,
  Number: (props) => <Text {...props} type="Number" />,
  Radio: (props) => <Radio {...props} />,
  RadioGroup: (props) => <RadioGroup {...props} />,
  Search: (props) => <Text {...props} type="Search" />,
  Select: (props) => <Select {...props} />,
  Text: (props) => <Text {...props} />,
  TextArea: (props) => <TextArea {...props} />,
};

export const FIELD_COMPONENTS = [
  'Checkbox',
  'CheckboxGroup',
  'Number',
  'Password',
  'Radio',
  'RadioGroup',
  'Search',
  'Select',
  'Text',
  'TextArea',
];

export const generateComponentForField = (type, props) => {
  if (FIELD_COMPONENTS.includes(type)) {
    return typeToComponentMap[type](props);
  }

  throw new Error(`
		generateComponentForField expected to receive a type that is one of the following: ${FIELD_COMPONENTS.join(' ')}\n
		but received type: ${type}
	`);
};
